import React, {useEffect, useState} from 'react';
import BasicHeader from "../../components/BasicHeader";
import AppContainer from "../../components/AppContainer";
import {useParams} from "react-router-dom";
import {LoadingSpinner} from "../../components/LoadingSpinner";
import OpsText from "../../ops-library/ops-text";
import formatDate from "../../functions/formatDate";
import OpsIcon from "../../ops-library/ops-icon";
import {FaEye} from "react-icons/fa";
import {IoTimeOutline} from "react-icons/io5";
import axios from "axios";
import opsToast from "../../ops-library/ops-toast";

const Article = () => {

    const {article_id} = useParams();
    const [article, setArticle] = useState({})
    const [theme, setTheme] = useState(
        localStorage.getItem("theme") != null
            ? localStorage.getItem("theme")
            : "light"
    );

    useEffect(() => {
        getArticleByID()
    }, []);


    function getArticleByID() {
        const configuration = {
            method: "get",
            url: `${process.env.REACT_APP_API_BASE_URL}/articles/article_id=${article_id}`,
        };

        axios(configuration)
            .then((result) => {
                setArticle(result.data.content)
            })
            .catch((error) => {
                console.log(error)
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
            });
    }

    return (
        <AppContainer
            showSlides={false}
            content={
                <div className="window-content-container py-5">
                    {
                        Object.entries(article).length === 0 ?
                            <div className="app-container fa-flex-col" data-theme={theme}>
                                <LoadingSpinner/>
                            </div>
                            :
                            <div className="fa-flex-col align-items-center mt-5 pt-5">
                                {/*TAGS*/}
                                <div className="fa-flex-wrap justify-content-center gap-1">
                                    {article?.tags.map((tag, index) =>
                                        <OpsText type="normal" weight={500} color="color-1" key={index}
                                                 className="bg-primary-3 px-2 rounded"
                                                 content={tag}/>
                                    )}
                                </div>

                                {/*TITLE*/}
                                <OpsText type="title2" weight={700} color="primary-5 mt-3 mb-2 article-title"
                                         content={article?.title}/>

                                {/*ARTICLE INFO*/}
                                <div className="fa-flex-row align-items-center gap-2 mt-2 mb-3">
                                    <OpsText type="label" color="color-1 me-3" alignment="left"
                                             content={formatDate(article?.createdAt)}/>
                                    <OpsIcon type="with-text" text={article?.views}
                                             source={<FaEye color="white" className="ops-icon-sm m-1"/>}/>
                                    <OpsIcon type="with-text" text={`${article?.readTime} min.`}
                                             source={<IoTimeOutline color="white" className="ops-icon-sm m-1"/>}/>
                                </div>

                                {/*PODNAZOV*/}
                                <OpsText type="normal1" color="color-1 mt-3 mb-2"
                                         content={article?.subtitle}/>

                                <div dangerouslySetInnerHTML={{__html: article.content}}/>

                                <div className="article-image mt-5">
                                    <img src={`${process.env.REACT_APP_API_BASE_URL}/${article.coverImg}`}
                                         className="w-100 h-100 object-fit-cover" alt=""/>
                                </div>
                            </div>
                    }
                </div>
            }
        />
    );
};

export default Article;